import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import CardCalendar from "../../../components/card-calendar/CardCalendar";
import { StoreContext } from "../../../store/StoreContext";

const Calendar = () => {
  const { promotions } = useContext(StoreContext);
  return (
    <Row>
      <Col col={12} className="mb-4">
        <CardCalendar promotions={promotions} />
      </Col>
    </Row>
  );
};

export default Calendar;
